module.exports = __webpack_public_path__ + "img/hdx.feaed27c.svg";